import React from "react";
import {IconNames} from "@blueprintjs/icons";
import {Button, Dialog} from "@blueprintjs/core";
import InfiniteScroll from "react-infinite-scroll-component";

import {IBlock} from '../../../../../../shared/models';
import CSVMergeOptionsForm from './CSVMergeOptionsForm';
import FilenameInput from '../FilenameInput';
import {validateSheetNames} from '../../../../../../shared/utils/validateSheetNames';

interface CSVDialogOptionsProps {
  isCSVDialogOpen: boolean;
  setIsCSVDialogOpen: (value: boolean) => void;
  mergeCsvConfig: any;
  csvMergeContent: IBlock[];
  onMergeCsvFilenameChange: (value: any) => void;
  onUpdateMergeCsvOption: (uid: string, updatedValues: any) => void;
  saveCsvMergeOptions: () => void;
  readOnly: boolean;
  content: any[];
}

const CSVDialogOptions = ({
  isCSVDialogOpen,
  setIsCSVDialogOpen,
  mergeCsvConfig,
  csvMergeContent,
  onMergeCsvFilenameChange,
  onUpdateMergeCsvOption,
  saveCsvMergeOptions,
}: CSVDialogOptionsProps) => {

  const getOption = (uid: string) => {
    return mergeCsvConfig.options.find((opt: any) => opt.uid === uid)
  }

  const {hasErrors, duplicates, tooLong} = validateSheetNames(mergeCsvConfig.options);

  return (
    <Dialog isOpen={isCSVDialogOpen} onClose={() => setIsCSVDialogOpen(false)} title="CSV Merge Options"
            icon={IconNames.COG}>
      <div className="csv-merge-dialog-content">
        <FilenameInput filename={mergeCsvConfig.filename} onChange={onMergeCsvFilenameChange} type={"csv"}/>

        <div className="csv-merge-table-container" id="csv_merge_infinite_scroll">
          <InfiniteScroll
            dataLength={mergeCsvConfig.options?.length || 0}
            next={() => { /* Not implemented yet */
            }}
            hasMore={false}
            loader={<div>Loading...</div>}
            scrollableTarget="csv_merge_infinite_scroll"
          >
            <table className="csv-merge-table">
              <thead>
              <tr className="csv-merge-header">
                <th>Content</th>
                <th>Include</th>
                <th>Position</th>
                <th>Sheet Name</th>
              </tr>
              </thead>
              <tbody>
              {mergeCsvConfig.enabled &&
                csvMergeContent.map((content: IBlock, index: number) => (
                  <CSVMergeOptionsForm
                    key={content.uid}
                    uid={content.uid}
                    name={content.name}
                    position={index}
                    option={getOption(content.uid)}
                    onUpdateMergeCsvOption={onUpdateMergeCsvOption}
                    positionLimit={csvMergeContent.length}
                    duplicateSheetNames={duplicates}
                    tooLongSheetNames={tooLong}
                  />
                ))}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>

        {hasErrors && (
          <div className="csv-merge-error-message bp4-text-danger">
            Please ensure all sheet names are unique and under 32 characters.
          </div>
        )}

        <div className="csv-merge-dialog-footer">
          <Button onClick={() => setIsCSVDialogOpen(false)}>Cancel</Button>
          <Button intent="primary" onClick={saveCsvMergeOptions} disabled={hasErrors}>
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default CSVDialogOptions;
